import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { Check, X } from "lucide-react";
import { API } from "../constants";
import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";

const CheckoutSuccessPage = () => {
  const location = useLocation();
  const { token } = useAuth();
  const { fetchCart } = useCart();
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sessionId = params.get('session_id');
    const isPaypal = params.get('paypal');

    if (isPaypal) {
      setStatus('success');
      return;
    }

    if (sessionId) {
      const checkStatus = async () => {
        try {
          const response = await axios.get(`${API}/checkout/status/${sessionId}`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          if (response.data.payment_status === 'paid') {
            setStatus('success');
            fetchCart();
          } else {
            setStatus('pending');
          }
        } catch (error) {
          setStatus('error');
        }
      };
      checkStatus();
      const interval = setInterval(checkStatus, 2000);
      setTimeout(() => clearInterval(interval), 30000);
      return () => clearInterval(interval);
    }
  }, [location, token, fetchCart]);

  return (
    <div className="min-h-screen bg-[#050505] pt-24 flex items-center justify-center">
      <div className="text-center max-w-md mx-auto px-4" data-testid="checkout-success">
        {status === 'checking' && (
          <>
            <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-[#D62828] mx-auto mb-6"></div>
            <h1 className="font-heading text-3xl mb-4">Processing Payment...</h1>
            <p className="text-gray-400">Please wait while we confirm your payment.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <Check className="w-10 h-10 text-white" />
            </div>
            <h1 className="font-heading text-3xl mb-4">Order Confirmed!</h1>
            <p className="text-gray-400 mb-8">Thank you for your purchase. We'll email you the order details.</p>
            <Link to="/orders" className="bg-[#D62828] hover:bg-[#B91C1C] text-white px-8 py-3 rounded-sm font-bold uppercase tracking-wider">View Orders</Link>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="w-20 h-20 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <X className="w-10 h-10 text-white" />
            </div>
            <h1 className="font-heading text-3xl mb-4">Payment Failed</h1>
            <p className="text-gray-400 mb-8">Something went wrong. Please try again.</p>
            <Link to="/cart" className="bg-[#D62828] hover:bg-[#B91C1C] text-white px-8 py-3 rounded-sm font-bold uppercase tracking-wider">Return to Cart</Link>
          </>
        )}
      </div>
    </div>
  );
};

export default CheckoutSuccessPage;
